export const getters = {
    getMedia(state) {
        return state.media;
    },
};